import { render, staticRenderFns } from "./EmailAlertDialog.vue?vue&type=template&id=458531a3&"
import script from "./EmailAlertDialog.vue?vue&type=script&lang=js&"
export * from "./EmailAlertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports